import { useEffect } from "react"

import DelayedCloseButton from "../../components/DelayedCloseButton/DelayedCloseButton"
import FeatureTermsList from "../../components/FeatureTermsList/FeatureTermsList"
import { useAppState } from "../../context/appStateContext"
import useStrings from "../../localization/useStrings"
import native from "../../native/native"
import styles from "./SpecialOfferPaywall.module.scss"
import { PurchasProvider } from "../../context/purchaseContext"
import { UltimateAlertsProvider } from "../../context/ultimateAlertsContext"
import SpecialOfferFooter from "./SpecialOfferFooter/SpecialOfferFooter"
import svg from "../../utils/svg"
import useQueryParams from "../../hooks/useQueryParams"
import UltimateSubfeaturesPopups from "../../components/UltimateSubfeaturesPopups/UltimateSubfeaturesPopups"
import FullScreenPage from "../../components/FullScreenPage/FullScreenPage"

const SpecialOfferPaywall = () => {
  const { actions } = useAppState()

  useEffect(() => {
    actions.setFooterInsetColor("var(-background)")
  }, [])

  return (
    <PurchasProvider>
      <UltimateAlertsProvider>
        <FullScreenPage>
          <div className={styles.container}>
            <Header />
            <div className={styles.scrollableList}>
              <FeatureTermsList />
            </div>
            <SpecialOfferFooter />
          </div>
        </FullScreenPage>
      </UltimateAlertsProvider>
    </PurchasProvider>
  )
}

const Header = () => {
  const strings = useStrings()

  const handleClose = () => {
    native.postNativeEvent("close")
  }

  const offer = useQueryParams().specialOffer
  const isExpiration = offer == "expiring"

  const iconStyle = isExpiration ? styles.warning : styles.normal
  const title = isExpiration
    ? strings.specialOffer.expirationTitle
    : strings.specialOffer.trialTitle
  const subtitle = isExpiration ? strings.specialOffer.expirationSubtitle : ""

  return (
    <div className={styles.headerContainer}>
      <DelayedCloseButton
        className={styles.closeButton}
        onClick={handleClose}
      />
      <div className={styles.headerContent}>
        <div className={`${styles.logo} ${iconStyle}`}>
          {<svg.PremiumBadge />}
        </div>
        <h1 className={styles.title} style={{ whiteSpace: "pre-line" }}>
          {title}
        </h1>
      </div>
      <label className={styles.subtitle}>{subtitle}</label>
    </div>
  )
}

export default SpecialOfferPaywall
